import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { notificationApiRef } from '../notificationApiRef';
import {
  HeadersByWebhookGetRequest,
  HeadersByWebhookGetResponse,
} from '@agilelab/plugin-wb-notification-common';
import { WEBHOOK_HEADERS } from './reactQuery';

export const useWebhookHeaders = (
  params: HeadersByWebhookGetRequest,
  options?: { enabled?: boolean },
) => {
  const notificationApi = useApi(notificationApiRef);

  return useQuery<HeadersByWebhookGetResponse>({
    queryKey: [WEBHOOK_HEADERS, params],
    queryFn: () => notificationApi.getWebhookHeaders(params),
    enabled: options?.enabled !== false,
  });
};
